import ExperienceService from '@/services/ExperienceService.js'

export const state = {
  experienceCategories: [],
  experienceCategory: {},
  experiences: [],
  experience: {},
  unitExperiences: [],
  unitExperience: {}
}

export const mutations = {
  SET_EXPERIENCE_CATEGORIES(state, experienceCategory) {
    state.experienceCategories = experienceCategory
  },
  SET_EXPERIENCES(state, experiences) {
    state.experiences = experiences
  },
  SET_EXPERIENCE(state, experience) {
    state.experience = experience
  },
  SET_EXPERIENCE_CATEGORY(state, experienceCategory) {
    state.experienceCategory = experienceCategory
  },
  SET_UNIT_EXPERIENCES(state, unitExperiences) {
    state.unitExperiences = unitExperiences
  },
  SET_UNIT_EXPERIENCE(state, unitExperience) {
    state.unitExperience = unitExperience
  },
  EDIT_UNIT_EXPERIENCE(state, unitExperience) {
    state.unitExperience = unitExperience
  },
  DELETE_UNIT_EXPERIENCE(state, unitExperience) {
    state.unitExperiences = state.unitExperiences.filter(t => t.id != unitExperience.unitId)
  },
  DELETE_EXPERIENCE_CATEGORY(state, experienceCategory) {
    state.experienceCategory = state.experienceCategories.filter(
      t => t.id != experienceCategory.id
    )
  },
  DELETE_EXPERIENCE(state, experience) {
    state.experience = state.experiences.filter(t => t.id != experience.id)
  },
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  createExperienceCategory({ dispatch }, experienceCategory) {
    return ExperienceService.postExperienceCategory(experienceCategory)
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your new experience category has been created!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem creating new experience category: ' +
            error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchExperienceCategories({ commit, dispatch }) {
    ExperienceService.getExperienceCategories()
      .then(response => {
        commit('SET_EXPERIENCE_CATEGORIES', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem fetching experience categories: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  updateExperienceCategoryById({ dispatch }, experienceCategory) {
    return new Promise((resolve) => {
        ExperienceService.updateExperienceCategoryById(experienceCategory.id, experienceCategory)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          const notification = {
            type: 'error',
            message:
              'There was a problem updating experience category by Id: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
        })
    })
  },
  fetchExperienceCategoryById({ commit, dispatch }, id) {
    return new Promise((resolve) => {
      const experienceCategory = getters.getExperienceCategoryById(id)

      if (experienceCategory) {
        commit('SET_EXPERIENCE_CATEGORY', experienceCategory)
        return resolve(experienceCategory)
      } else {
        ExperienceService.getExperienceCategoryById(id)
        .then(response => {
          return resolve(response.data[0])
        })
        .catch(error => {
          const notification = {
            type: 'error',
            message:
              'There was a problem fetching experience category by Id: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
        })
      }
    })
  },
  upsertExperience({ dispatch }, experience) {
    return ExperienceService.postExperience(experience)
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your new experience has been created!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating your experience: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchExperienceById({ commit, dispatch }, id) {
    return new Promise((resolve) => {
      const experience = getters.getExperienceById(id)

      if (experience) {
        commit('SET_EXPERIENCE', experience)
        return resolve(experience)
      } else {
        ExperienceService.getExperienceById(id)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          const notification = {
            type: 'error',
            message:
              'There was a problem fetching experience: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
        })
      }
    })
  },
  fetchExperiences({ commit, dispatch }) {
      ExperienceService.getExperiences()
      .then(response => {
        commit('SET_EXPERIENCES', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem fetching experience: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  searchExperiences({ commit, dispatch }, searchTerm) {
    ExperienceService.searchExperiences(searchTerm)
    .then(response => {
      commit('SET_EXPERIENCES', response.data)
    })
    .catch(error => {
      const notification = {
        type: 'error',
        message:
          'There was a problem fetching experience: ' + error.message
      }
      dispatch('notification/add', notification, { root: true })
    })
  },
  fetchUnitExperiences({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      ExperienceService.getUnitExperiences(id)
      .then(response => {
        commit('SET_UNIT_EXPERIENCES', response.data)
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem fetching unit experiences: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        return reject(error)
      })
    })
  },
  createUnitExperience({ commit, dispatch }, unitExperience) {
    return ExperienceService.postUnitExperience(unitExperience)
      .then(() => {
        commit('SET_UNIT_EXPERIENCE', unitExperience)
        const notification = {
          type: 'success',
          message: 'Your new experience has been added to the unit!'
        }
        dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem adding experience to the unit: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchUnitExperience({ commit }, { unitId, experienceId }) {
    const unitExperience = getters.getUnitExperienceById(unitId, experienceId)

    if (unitExperience) {
      commit('SET_UNIT_EXPERIENCE', unitExperience)
      return unitExperience
    } else {
      return ExperienceService.getUnitExperience(unitId, experienceId) // <-- Send the prop ids to our ProductService//
        .then(response => {
          commit('SET_UNIT_EXPERIENCE', response.data[0])
          return response.data[0]
        })
    }
  },
  editUnitExperience({ commit }, unitExperience) {
    ExperienceService.updateUnitExperience(unitExperience)
    commit('EDIT_UNIT_EXPERIENCE', unitExperience)
  },
  async removeUnitExperience({ commit }, unitExperience) {
    await ExperienceService.deleteUnitExperience(unitExperience.unitId, unitExperience.experienceId)
    commit('DELETE_UNIT_EXPERIENCE', unitExperience)
  },
  async removeExperienceCategory({ commit }, experienceCategory) {
    return ExperienceService.deleteExperienceCategory(experienceCategory)
    .then((response) => {
      if (response.data.success === true) {
        commit('DELETE_EXPERIENCE_CATEGORY', experienceCategory)
      } else {
        alert(response.data.message)
      }
    })
    .catch(error => {
      throw error
    })
  },
  async removeExperience({ commit }, experience) {
    return ExperienceService.deleteExperience(experience)
    .then((response) => {
      if (response.data.success === true) {
        commit('DELETE_EXPERIENCE', experience)
      } else {
        alert(response.data.message)
      }
    })
    .catch(error => {
      throw error
    })
  },
  searchUnitExperiences({ commit, dispatch }, searchJson) {
    ExperienceService.searchUnitExperiences(searchJson.id, searchJson.search)
      .then(response => {
        commit('SET_UNIT_EXPERIENCES', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem searching unit experiences: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  }
}

export const getters = {
  getExperienceById: id => {
    return state.experiences.find(experience => experience.id === id)
  },
  getExperienceCategoryById: id => {
    return state.experienceCategories.find(experienceCategory => experienceCategory.id === id)
  },
  getUnitExperienceById: (unitId, experienceId) => {
    return state.unitExperiences.find(
      unitExperience => 
      (unitExperience.unit_id === unitId,unitExperience.experience_id === experienceId))
  }
}
